import React from 'react';
import { Table as BootstrapTable } from 'react-bootstrap';

const Table = ({ 
    children, 
    striped = false, 
    bordered = false, 
    borderless = false, 
    hover = false, 
    size, 
    variant,
    responsive = false,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    const table = (
        <BootstrapTable 
            striped={striped} 
            bordered={bordered} 
            borderless={borderless}
            hover={hover} 
            size={size}
            variant={variant}
            className={className} 
            style={style}
            {...props}
        >
            {children}
        </BootstrapTable>
    );

    if (responsive) {
        return <div className="table-responsive">{table}</div>;
    }

    return table;
};

export default Table;

